<template>
  <div class="home">
    <van-nav-bar
      :title="$t('print.name')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
    </van-nav-bar>
    <van-cell-group>
      <van-cell :title="$t('print.kitchen')" is-link @click="changedialog('kitchen')" />
      <van-cell
        :title="$t('print.cash')"
        is-link @click="changedialog('cash')"
      />
      <van-cell
        :title="$t('print.order')"
        is-link @click="changedialog('order')"
      />
      <van-cell
        :title="$t('print.handover')"
        is-link
        @click="goPrinterSet('handover')"
      />
      <van-cell
        :title="$t('print.addmenu')"
        is-link @click="changedialog('addmenu')"
      />
      <van-popup v-model:show="dialog" round position="bottom">
        <van-picker
          confirm-button-text="确定"
          cancel-button-text="取消"
          :columns="columns"
          @cancel="dialog = false"
          @confirm="cConfirm"
          :default-index="0"
          :show-toolbar="true"
        />
      </van-popup>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: ["堂食", "打包", "外卖"],
      dialog: false,
    };
  },
  mounted: function () {},
  methods: {
    goPrinterSet(type) {
      this.$router.push("/PrintSet/" + type);
    },
    changedialog(type){
      this.type=type
      this.dialog=true
    },
    cConfirm(value, index) {
      console.log(value, index);
      this.$router.push({
        path: "/PrintSet/" + "kitchen",
        query: { kitchenv: `${index}`,type:this.type },
      });
    },
  },
};
</script>
<style scoped>
/deep/ .van-picker__confirm {
  color: #2f75f4 !important;
}
/deep/ .van-picker__cancel {
  color: #2f75f4 !important;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-field__control {
  text-align: right;
}
.home {
  width: 100%;
  /* height: 100%; */
  padding-bottom: 60px;
  background: #f3f5f7;
  /* margin: -40px 0 0 0; */
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ffc914;
}
/deep/ .van-cell-group {
  background: #f3f5f7;
}
.bottom {
  position: fixed;
  bottom: 0;
}
</style>




// WEBPACK FOOTER //
// src/Print/PrintList.vue